import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export interface updateAdminProductsAboutParams {
	description: string;
	rules: string;
	awards: string;
	earnings_projection: string;
}

export async function updateAdminProductsAbout(
	data: Partial<updateAdminProductsAboutParams>,
	id: string,
): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.put(`/product/update-about/${id}`, data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
